import React from 'react';
import '../styles/ownerMsg.css'; // Optional: extract styles here later if needed

const OwnerMsgTeam = () => {
  return (
    <section className="section bg-white owner-message">
      <div className="section-inner">
        <div className="owner-content">
          <div className="owner-image">
            <img 
              src="/images/matt_Taylor.jpeg"
              alt="Matthew Taylor, Owner" 
            />
          </div>
          <div className="owner-text">
            <h2>A Message from Our Owner</h2>
            <p className="owner-intro">Matthew Taylor, Owner & President</p>
            <blockquote>
              "At All Seasons, we don't just build landscapes — we build careers rooted in purpose, pride, and community. Our team is the heart of everything we do."
            </blockquote>
            <p>
              If you're passionate about the outdoors, take pride in your craft, and want to be part of a company that values integrity, growth, and Idaho’s natural beauty — you’re in the right place.
            </p>
            <p>
              Joining All Seasons means becoming part of a legacy of excellence that’s been growing since 1990. We support each other, celebrate the work we do, and take pride in transforming spaces across every season.
            </p>
            <p>
              I invite you to explore our open roles and find your place on a team that’s shaping the landscape — and the future — of the Wood River Valley.
            </p>
            <div className="owner-signature">
              <img 
                src="/images/mTaylorSig.png" 
                alt="Matthew Taylor Signature" 
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OwnerMsgTeam;
